import React, { useState } from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import Socials from "./Socials"
import NavOptions from "./NavOptions"
import Bag from "./Bag"

import { BiMenuAltLeft } from "react-icons/bi"
import { MdClose } from "react-icons/md"

const MobileNav = () => {
  const [showMenu, setShowMenu] = useState(false)

  let menuOverlay

  if (showMenu) {
    menuOverlay = (
      <MenuOverlay
        onClick={() => {
          setShowMenu(false)
        }}
      />
    )
  }

  return (
    <>
      <Navbar>
        <Bars onClick={() => setShowMenu(!showMenu)} />
        <Logo to="/">
          <h1>Giovanni Vitali</h1>
          <h2>photography</h2>
        </Logo>
        <Bag />
      </Navbar>
      <Menu showMenu={showMenu}>
        <TitleContainer>
          <Close onClick={() => setShowMenu(!showMenu)} />
          <h1>Menu</h1>
        </TitleContainer>
        <nav onClick={() => setShowMenu(false)}>
          <NavOptions />
        </nav>
        <Socials />
      </Menu>
      {menuOverlay}
    </>
  )
}

export default MobileNav

const Navbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
`

const Bars = styled(BiMenuAltLeft)`
  font-size: 2rem;
  cursor: pointer;
  height: 100%;
`

const Logo = styled(Link)`
  color: #000;
  text-decoration: none;
  text-align: center;

  h1,
  h2 {
    font-family: "julius sans one", serif;
  }
`

const Menu = styled.div`
  background-color: #fff;
  width: 60%;
  max-width: 400px;
  position: fixed;
  height: 100%;
  z-index: 999;
  top: 0;

  left: ${props => (props.showMenu ? "0" : "-60%")};
  transition: ${props => (props.showMenu ? "500ms" : "300ms")};
`

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-family: "julius sans one", serif;
  padding-right: 2.5px;
`

const Close = styled(MdClose)`
  cursor: pointer;
  font-size: 2rem;
  height: 80px;
`

const MenuOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  z-index: 998;
  background-color: rgba(0, 0, 0, 0.25);
`
